// extracted by mini-css-extract-plugin
module.exports = {"section":"Footnotes_section__4K9uT"};